export default function xor(a = false, b = false) {
  return a ? !b : b
}
